module.exports = __webpack_public_path__ + "static/media/users-purple.b1280745.svg";